import React from 'react';
import PhoneService from './PhoneService';
import { KINGMAN_PHONE } from '../data/localSeoContent';

const PhoneKingman: React.FC = () => (
  <PhoneService
    city="Kingman"
    heroTitle={
      <>
        Phone Service in
        <br />
        <span className="text-white">Kingman, Arizona</span>
      </>
    }
    heroSubtitle="Reliable home and business phone service in Kingman — unlimited calling, number porting, and local Airmax support."
    localSeo={KINGMAN_PHONE}
  />
);

export default PhoneKingman;
